export function Modal({ open, onOpenChange, header, children }) {
  if (!open) {
    return null;
  }

  return (
    <div
      className="ui-modal__overlay"
      onClick={() => onOpenChange && onOpenChange(false)}
    >
      <div
        className="ui-modal__sheet"
        onClick={(event) => event.stopPropagation()}
      >
        {header}
        <div className="ui-modal__scroll">{children}</div>
      </div>
    </div>
  );
}

export function ModalHeader({ before, after, children }) {
  return (
    <div className="ui-modal-header">
      {before}
      {after}
    </div>
  );
}

export function ModalClose({ children, onClick }) {
  return (
    <button type="button" className="ui-modal-close" onClick={onClick}>
      {children}
    </button>
  );
}
